var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contactanos"},[_c('span',[_vm._v("Comience a transformar su empresa hoy")]),_c('div',{staticClass:"dvBoton"},[_c('router-link',{attrs:{"to":"Contacto"}},[_vm._v("Contactanos")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }